<template>

	<div class="container main-content">
		<div class="row">
			<div class="col-12 text-center" style="outline:none" tabindex="-1" role="group">
				<iframe
					class="credit-card-frame"
					allow="accelerometer; autoplay; camera; gyroscope; payment"
					frameborder="0"
					height="100%"
					:src="iframeUrl"
					width="100%"
				>
				<p>Your browser does not support iframes.</p>
				</iframe>
			</div>
		</div>
		
		<div class="row">
			<div class="col-12 text-center mt-5">
				<img src="./../assets/img/powered_by_moonpay.png" class="img-fluid mb-1">
				<p class="mb-1 mt-3" ><small class="text-muted" style="font-size: 70%">Visa / Mastercard processing provided by Moon Pay Limited. <br />By continuing, you are agreeing to MoonPay's  <a href="https://www.moonpay.io/terms_of_use" target="_blank">Terms of Service</a>, <a href="https://www.moonpay.io/privacy_policy" target="_blank">Privacy Policy</a>, and <a href="https://www.moonpay.com/aml_kyc_policy" target="_blank">AML/KYC Policy</a>.</small></p>
				
			</div>
		</div>
		
	</div>

</template>

<script>

export default {
	data() {
		return {
			pq: this.$gstate.getFlowState(),
		}
	},
	created() {
		if(this.$gstate.getMoonpayApiKey() == undefined){
			this.$gstate.log("Invalid api key");
			this.$gstate.redirectHome(100, 1000, 'Invalid api key');
			return;
		}
	},
	mounted(){
		this.runMoonPaySafariFix();
	},
	computed:{
		iframeUrl(){
			var url =  this.$gstate.getMoonpayBaseURL()
				+ "?apiKey=" + this.$gstate.getMoonpayApiKey()
				+ "&colorCode=%23" + this.$gstate.getMoonpayColorCode()
				+ "&currencyCode=" + this.pq.cryptoCurrency
				+ "&baseCurrencyCode=" + this.pq.fiatCurrency
				+ "&baseCurrencyAmount=" + this.pq.fiatAmount

			this.$gstate.log(url);

			return url;
		}
	},
	methods: {
		runMoonPaySafariFix() {
			var isSafari = navigator.userAgent.indexOf("Safari") > -1;

			if (!isSafari) {
				return;
			}

			var isChrome = navigator.userAgent.indexOf("Chrome") > -1;

			if (isChrome) {
				return;
			}

			if (!document.cookie.match(/^(.*;)?\s*moonpay-fixed\s*=\s*[^;]+(.*)?$/)) {
				document.cookie =
				"moonpay-fixed=fixed; expires=Tue, 19 Jan 2038 03:14:07 UTC; path=/";
				window.location.replace("https://buy.moonpay.io/safari_fix");
			}
		}

	}
}
</script>
